import { Component, QueryList, ViewChildren } from '@angular/core';
import { IonicPage, NavController, Platform, Events } from 'ionic-angular';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../services/ebsWebService";
import { Slides } from 'ionic-angular';

@IonicPage({
  name: 'Home'
})
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers: [
    EbsWebServiceGlobals,
    EbsWebService
  ],
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class HomePage {
  @ViewChildren(Slides) slides: QueryList<Slides>;
  showGlobalSearchBar: boolean = true;
  showContactObject: boolean = false;
  showGridBoxSlider: boolean = false;
  progressElements: any = [];
  mainContactObjects: any = [];
  loaded: boolean = false;
  gridBoxSliderObjects: any = [];
  title: string = "";
  numbers: any;
  sliderBreakpoint: any = 4;
  cordova: boolean = false;
  counterItemsLength: number = 0;

  showHomepageInformationComponent: boolean = false;
  homepageInformationHeader: any;
  homepageInformationContent: any;

  showHomepageTableComponent: boolean = false;
  homepageTableData: any = [];

  showHomepageChartComponent: boolean = false;
  homepageChartData: any = [];
  loadedCharts: boolean = false;

  constructor(public navCtrl: NavController,
    private _ebsWebService: EbsWebService,
    public events: Events,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals,
    private platform: Platform) {
    if (this.platform.is('ios') || this.platform.is('android')) {
      this.cordova = true;
    }
    this.setScreenSize();
    this.events.subscribe('setting:ConfigFileLoaded', () => {
      this.loaded = true;
      this.events.unsubscribe('setting:ConfigFileLoaded', null);
      this.loadHomeScreenData();
    });

  }

  ionViewWillEnter() {
    if (this.loaded) {
      this.loadHomeScreenData();
    } else {
      this._ebsWebServiceGlobals.loadConfigFile();
    }
  }

  loadHomeScreenData() {
    let queryParams = JSON.parse(this._ebsWebService.buildPostPayloadObjectFromGetParameters(window.location.search.substring(1)));
    let postPayload = { userKey: "null" };
    let hasHash = false;
    if (queryParams != undefined && queryParams != null && queryParams['hash'] != undefined && queryParams['hash'] != null) {
      let hash = queryParams['hash'];
      console.log('hash found in query string:', hash);
      postPayload.userKey = hash;
      hasHash = true;
    } else {
      console.log('no hash found in query string');
    }


    console.log(this._ebsWebServiceGlobals.getEBSWebServiceMainContentURL())
    this._ebsWebService.postData(this._ebsWebServiceGlobals.getEBSWebServiceMainContentURL(), hasHash ? postPayload : null).subscribe(res => {
      console.log("res", res);
      if (res.ListItemContent != null) {
        this.progressElements = [];
        this.mainContactObjects = [];
        this.homepageTableData = [];
        this.gridBoxSliderObjects = [];
        res.ListItemContent.forEach(element => {
          if (typeof element.GroupTemplateIdentifier != "undefined" && element.GroupTemplateIdentifier != null) {
            if (element.FieldName != "undefined" && element.FieldName == "showGlobalSearchBar" && element.EditValue != "undefined") {
              this.showGlobalSearchBar = JSON.parse(element.EditValue.toLowerCase());
            } else if (element.GroupTemplateIdentifier.indexOf("Contact") != -1) {
              this.showContactObject = true;
              this.mainContactObjects.push(JSON.parse(element.DisplayText));
            } else if (element.GroupTemplateIdentifier.indexOf("HomepageInformation") != -1) {
              this.showHomepageInformationComponent = true;
              this.homepageInformationHeader = res.ListItemContent.filter(obj => obj.FieldName == "HomepageInformationHeader")[0].DisplayText;
              this.homepageInformationContent = res.ListItemContent.filter(obj => obj.FieldName == "HomepageInformationContent");
            } else if (element.GroupTemplateIdentifier.indexOf("HomepageTable") != -1) {
              this.showHomepageTableComponent = true;
              console.log(element.EditValue);
              this.homepageTableData.push(JSON.parse(element.EditValue));
            } else if (element.GroupTemplateIdentifier.indexOf("GridBoxGroup") != -1) {
              this.showGridBoxSlider = true;
              this.gridBoxSliderObjects.push(element);
            } else if (element.GroupTemplateIdentifier.indexOf("Chart") != -1) {
              this.showHomepageChartComponent = true;
              if (this.loadedCharts == false) {
                this.homepageChartData.push(JSON.parse(element.EditValue));
              }
            }
          }
          this.loadProgressCircleIfExists(element);
        });
        this.loadedCharts = true;
      }

      if (typeof res.Caption != "undefined" && res.Caption != null) {
        this.title = res.Caption;
      }

      this._ebsWebService.setBrowserTabTitle(res.MainTitle);
    });
  }

  loadProgressCircleIfExists(element) {
    if (typeof element.Dynamic != "undefined" && element.Dynamic != null) {
      if (typeof element.Dynamic.ChartType != "undefined" && element.Dynamic.ChartType != null && element.Dynamic.ChartType == "Progress") {
        //let progressObject = {title:element.GroupDisplayName,is:element.DisplayText,should:element.EditValue,unit:element.FieldName,separator:element.LabelCaption}
        this.progressElements.push(element.Dynamic);
      }
    }
  }

  onResize() {
    this.setScreenSize();
  }

  setScreenSize() {
    if (window.innerWidth <= 960) {
      this.sliderBreakpoint = 1;
    } else if (window.innerWidth >= 961 && window.innerWidth <= 1240) {
      this.sliderBreakpoint = 2;
    } else if (window.innerWidth >= 1241 && window.innerWidth <= 1440) {
      this.sliderBreakpoint = 3;
    } else if (window.innerWidth >= 1441) {
      this.sliderBreakpoint = 4;
    }
  }

  next(countid: number) {
    this.slides.toArray()[countid].slideNext();
    console.log(this.slides.toArray());
    console.log("ButtonID(INDEX): " + countid + " - NichtSliderItems: " + this.counterItemsLength + " = SLIDER ID: " + countid)
  }

  prev(countid: number, event) {
    this.slides.toArray()[countid].slidePrev();
    console.log(this.slides.toArray());
    console.log("ButtonID(INDEX): " + countid + " - NichtSliderItems: " + this.counterItemsLength + " = SLIDER ID: " + countid)
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts